import { JsPdfFont, loadFontsJsPdf } from "./module";

const fonts = [
  new JsPdfFont({
    path: `${process.env.VUE_APP_S3_AMAZON_AWS}/assets/fonts/Thai-Bold.js`,
    variableName: "thaiBoldFont",
    filename: "NotoSansThai-Bold-bold.ttf"
  })
];

export const downloadFontsJsPdf = async (doc?: any) => await loadFontsJsPdf(fonts, doc);
